import * as yup from "yup";

export const validations = {
  idActividadEconomica: yup
    .string()
    .required("Campo requerido"),
};
